import Template from "../utils/template";


export default class FormGroupKeyValue {
  constructor() {
    this.container = document.querySelector('.js-form-group-key-value-container');
    if (!this.container) {
      return;
    }

    this.inputTemplate = this.container.querySelector('.js-form-group-key-value.add').dataset.prototype;

    this.FORM_GROUP_TEMPLATE = `
      <div class="js-form-group-key-value">
        <div class="form-group d-flex justify-content-between align-items-end">
          ${ this.inputTemplate }
          <div>
            <button type="button" class="btn btn-scarlet w-xs-110p text-white js-form-group-key-value-action" data-action="delete">Delete</button>
          </div>
        </div>
      </div>
    `;


    this.entryContainer = this.container.querySelectorAll('.js-form-group-key-value');
    if (this.entryContainer.length) {
      for (const entryContainer of this.entryContainer) {
        this.handleEntry(entryContainer)
      }
    }
  }

  handleEntry(container) {
    const self = this;
    const button = container.querySelector('.js-form-group-key-value-action');
    if (button.dataset.action === 'add') {
      button.addEventListener('click', self.onAddNewEntry.bind(this, container))
    }
    if (button.dataset.action === 'delete') {
      button.addEventListener('click', () => {
        container.remove()
      })
    }
  }

  onAddNewEntry(container) {
    const keyInput = container.querySelector('input[name="new_key"]')
    const valueInput = container.querySelector('input[name="new_value"]')

    if (!keyInput.value && !valueInput.value) {
      return;
    }

    const timestamp = new Date().toISOString().replace(/[-:.]/g, '');
    const random = ('' + Math.random()).substring(2, 8);
    const randomNumber = timestamp + random;

    const formGroupTemplate = this.FORM_GROUP_TEMPLATE.replace(/__name__/g, randomNumber);
    const newInputs = new Template(formGroupTemplate, {});

    const parser = new DOMParser();
    const newElement = parser.parseFromString(newInputs.build(), 'text/html');
    const newContainer = newElement.body.children[0];
    this.container.append(newContainer)
    newContainer.querySelector('.key-input').value = keyInput.value
    newContainer.querySelector('.value-input').value = valueInput.value
    this.handleEntry(newContainer)

    keyInput.value = '';
    valueInput.value = '';
  }
}
